'use client';

import * as DS from '@aurorasolar/ds';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

export const RedirectToastHandler = () => {
  const pathname = usePathname();
  const router = useRouter();
  const searchParams = useSearchParams();
  const { upsert } = DS.useNotifications();

  useEffect(() => {
    const redirectedFrom = searchParams.get('redirected_from');

    if (redirectedFrom === 'heliose') {
      upsert({
        config: {
          description: 'Heliose is now Aurora Solar. Same trusted estimates, new name.',
          title: "You're in the right place",
          variant: 'info',
        },
        id: 'toast',
        type: 'toast',
      });

      // Remove the redirected_from query param from URL
      const newParams = new URLSearchParams(searchParams);
      newParams.delete('redirected_from');

      const newQueryString = newParams.toString();
      router.replace(`${pathname}${newQueryString ? `?${newQueryString}` : ''}`, { scroll: false });
    }
  }, [pathname, router, searchParams, upsert]);

  return null;
};
